<template>
    <el-dialog :visible.sync="visible" title="发票认领" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :model="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" label-width="120px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label-width="120px" label="项目部：">
                        <el-select v-model="dataForm.deptName" placeholder="请选择项目部"  @change="getProjectList">
                            <el-option :label="deptItem.applyDeptName" :value="deptItem" v-for="(deptItem,deptIndex) in deptList" :key="'deptItem'+deptIndex"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label-width="120px" label="项目名称：">
                        <el-select v-model="dataForm.projectName" placeholder="请选择项目名称" @change="getSubInfoList">
                            <el-option :label="projectItem.name" :value="projectItem" v-for="(projectItem,projectIndex) in projectList" :key="'projectItem'+projectIndex"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label-width="120px" label="分项合同名称：">
                        <el-select v-model="dataForm.subContractName" placeholder="请选择分项合同" @change="setSubInfo">
                            <el-option :label="subItem.name" :value="subItem" v-for="(subItem,subIndex) in subInfoList" :key="'subItem'+subIndex"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label-width="120px" label="分项合同编号：">
                        <el-input v-model="dataForm.serialNumber" placeholder="分项合同编号" disabled clearable></el-input>
                    </el-form-item>
                </el-col>
              <el-col :span="12">
                <el-form-item label-width="120px" label="认领日期：">
                  <el-date-picker
                      v-model="dataForm.claimDate"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
        </el-form>
        <template slot="footer">
            <el-button type="info" @click="visible = false">取消</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">保存</el-button>
        </template>
    </el-dialog>
</template>

<script>
    import {
        getDeptListService,
        getProjectListService,
        querySubInfoByProjectIdService,
        claimConfirmService,
    } from '@/services/invoiceServices'
    export default {
        name: "claim-confirm",
        data () {
            return {
                visible: false,
                dataForm:{
                    idList:[],
                    deptId: "",
                    deptName: "",
                    projectId: "",
                    projectName: "",
                    subContractId: "",
                    subContractName: "",
                    serialNumber: "",
                    claimDate: "",
                },
                deptList:[], //项目部列表
                projectList:[], //项目列表
                subInfoList:[], //分项合同列表
            }
        },
        methods: {
            init () {
                this.visible = true;
                this.dataForm ={
                  ...this.dataForm,
                  deptId: "",
                  deptName: "",
                  projectId: "",
                  projectName: "",
                  subContractId: "",
                  subContractName: "",
                  serialNumber: "",
                  claimDate: this.getDate(),
                }
                this.getDeptList();
            },
            getDate() {
                let now = new Date();
                let year = now.getFullYear(); //得到年份
                let month = now.getMonth(); //得到月份
                let date = now.getDate(); //得到日期
                let hour = " 00:00:00"; //默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
                month = month + 1;
                month = month.toString().padStart(2, "0");
                date = date.toString().padStart(2, "0");
                let defaultDate = `${year}-${month}-${date}`;//
                return defaultDate;
            },
            /**
             *  获取项目部列表
             * */
            getDeptList(){
                getDeptListService().then( res => {
                    if(res.code == 10000000){
                        this.deptList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             * 获取项目列表
             * */
            getProjectList(item){
                console.log(item)
                this.dataForm.deptId = item.applyDeptId;
                this.dataForm.deptName = item.applyDeptName;
                this.dataForm.projectId = '';
                this.dataForm.projectName = '';
                this.subInfoList = [];
                this.dataForm.subContractId = '';
                this.dataForm.subContractName = '';
                let paramsData = {
                    deptId: this.dataForm.deptId
                }
                getProjectListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.projectList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            /**
             * 获取分项合同列表
             * */
            getSubInfoList(item){
                this.dataForm.projectId = item.id;
                this.dataForm.projectName = item.name;
                this.dataForm.subContractId = '';
                this.dataForm.subContractName = '';
                let paramsData = {
                    projectId: this.dataForm.projectId
                }
                querySubInfoByProjectIdService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.subInfoList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            // 设置选择的分项合同数据
            setSubInfo(item){
                this.dataForm.subContractId = item.id;
                this.dataForm.subContractName = item.name;
                this.dataForm.serialNumber = item.serialNumber;
            },
            // 表单提交
            dataFormSubmitHandle() {
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return false
                    }
                    if(!this.dataForm.claimDate){
                        this.$message.error('请选择认领日期！');
                        return
                    }
                    claimConfirmService(this.dataForm).then( res => {
                        if(res.code == 10000000){
                            this.$message({
                                message: '认领成功',
                                type: 'success',
                                duration: 500,
                                onClose: () => {
                                    this.visible = false
                                    this.$emit('refreshDataList')
                                }
                            })
                        }else{
                            this.$message.error(res.msg);
                        }
                    }).catch(error => {
                        this.$message.error("网络请求失败");
                    });
                })
            },
        }
    }
</script>

<style scoped>
    /deep/.el-select{
        width: 100%;
    }
</style>
